import request from 'lib/request';

export interface Response {
  code: number;
  data: ProjectDetail;
  msg: string;
}

export interface ProjectDetail {
  active_raffles: ActiveRaffle[];
  project_vo: DataProject;
  project_whitelist: ProjectWhitelist[];
}

export interface ActiveRaffle {
  /**
   * 我的参与记录详情
   */
  my_entry?: MyEntry;
  /**
   * raffle 名字
   */
  name?: string;
  /**
   * 项目详情
   */
  campaign?: ActiveRaffleCampaign;
  /**
   * url唯一标识
   */
  vanity_url?: string;
}

/**
 * 我的参与记录详情
 */
export interface MyEntry {
  /**
   * 是否中奖
   */
  is_win: number;
  /**
   * mint wallet
   */
  mint_wallet: string;
}

/**
 * 项目详情
 */
export interface ActiveRaffleCampaign {
  id: number;
  logo: string;
  name: string;
  twitter_link: string;
}

export interface DataProject {
  /**
   * 项目banner
   */
  banner: string;
  /**
   * blockchain包含：Ethereum， Polygon， BNB， Arbitrum， Optimism， ZKSync
   */
  chain?: string;
  /**
   * discord邀请链接
   */
  dc_invite_link?: string;
  /**
   * 是否在这个项目下中过奖
   */
  has_won: boolean;
  /**
   * 物理主键
   */
  id?: number;
  /**
   * 是否推荐
   */
  is_recommend: boolean;
  /**
   * 是否追踪该项目
   */
  is_tracked: boolean;
  logo: string;
  /**
   * mint时间
   */
  mint_date?: string;
  /**
   * mint时间
   */
  mint_time: string;
  /**
   * 项目名称
   */
  name?: string;
  /**
   * public price
   */
  public_price?: string;
  /**
   * 这个项目有多少raffle
   */
  raffle_count: number;
  /**
   * supply count
   */
  supply_count?: string;
  /**
   * 追踪人数
   */
  track_amount: number;
  /**
   * 推特链接
   */
  twitter_screen_name?: string;
  /**
   * website
   */
  website?: string;
  /**
   * whitelist price
   */
  whitelist_price?: string;
}

export interface ProjectWhitelist {
  address: string;
  has_won: boolean;
  id: number;
}

export async function getProjectDetail(id: number) {
  const res = await request<Response>('/project/detail', {
    params: {
      id,
    },
  });
  return res?.data;
}
